module.exports = __webpack_public_path__ + "img/jobdescription.80384497.svg";